import { createStateSelectorHook } from 'src/lib/sweetState';
import { useIsApplicationModeInfinity } from 'src/services';

import { INFINITY_EXTENSION_MODE } from '../const';
import { LocalStore } from '../store';

const useLocalState = createStateSelectorHook(LocalStore, ['infinityExtensionMode']);

export const useInExtensionVariationsMode = () => {
  const isAppModeInfinity = useIsApplicationModeInfinity();
  const { infinityExtensionMode } = useLocalState();

  return (
    isAppModeInfinity && infinityExtensionMode === INFINITY_EXTENSION_MODE.variationsGeneration
  );
};
